import { useEffect } from 'react';
import { interactiveExperienceCompletedRef } from './interactiveExperienceCompletedRef.tsx';
import { UniversalCreateButtonInteractiveExperience } from './UniversalCreateButtonInteractiveExperience.tsx';

export const useUniversalCreateButtonInteractiveExperienceComplete = (): void => {
	// Mark experience as completed and prevent failure() from being called by the timeout
	useEffect(() => {
		interactiveExperienceCompletedRef.current = true;
		UniversalCreateButtonInteractiveExperience.success();
	}, []);
};
